import {Expressions} from '@packages/systems/wfdl';
import type {Expression, ExpressionElement} from '@packages/systems/wfdl-ast';

export const updateElementData =
  (fn: (data: Expression) => Expression) => (el: ExpressionElement) => {
    const {data} = el;
    const newData = fn(data);
    return newData === data ? el : {...el, data: newData};
  };

export const updateElementDataWithTyped =
  (fn: (data: Expression) => Expression) => (el: ExpressionElement) =>
    Expressions.setElementData(el, fn(Expressions.getElementData(el)));
